import { render, staticRenderFns } from "./MartinelliContainer.vue?vue&type=template&id=4bc44c3c&"
import script from "./MartinelliContainer.vue?vue&type=script&lang=js&"
export * from "./MartinelliContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports